export const emailMatchesAllowedDomains = (value: string, allowedDomains: string[]) => {
  const normalized = String(value || '').trim().toLowerCase();
  const atIndex = normalized.lastIndexOf('@');
  if (atIndex <= 0 || atIndex === normalized.length - 1) {
    return false;
  }

  const emailDomain = normalized.slice(atIndex + 1);
  return allowedDomains.some((allowedDomainRaw) => {
    const allowedDomain = String(allowedDomainRaw || '')
      .trim()
      .toLowerCase()
      .replace(/^@/, '')
      .replace(/\.$/, '');
    if (!allowedDomain) return false;
    return emailDomain === allowedDomain || emailDomain.endsWith(`.${allowedDomain}`);
  });
};

export const allowedDomainValidationMessage = (allowedDomains: string[]) =>
  `Email must end with one of: ${allowedDomains.join(', ')}`;

